import { useState } from 'react';
import { Draggable } from '@hello-pangea/dnd';
// @mui
import { Paper, Typography, Box } from '@mui/material';
import { currentFormat } from '@/utils/cases';
import { translates } from '@/utils';
import { onClickTaskCardProps } from './column/KanbanColumn';

// ----------------------------------------------------------------------

type Props = {
  index: number;
  card: any;
  columnId: string;
  onDeleteTask: (id: string) => void;
  onClick?: onClickTaskCardProps;
};

export default function KanbanTaskCard({ card, onDeleteTask, index, onClick, columnId }: Props) {
  const { name, quantity, price } = card;

  const [completed] = useState(card.completed);

  return (
    <Draggable draggableId={card.id} index={index}>
      {(provided) => (
        <Paper
          onClick={() => onClick && onClick(card.id, columnId)}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          sx={{
            width: 1,
            borderRadius: 1,
            overflow: 'hidden',
            position: 'relative',
            boxShadow: (theme) => theme.customShadows.z1,
            '&:hover': {
              boxShadow: (theme) => theme.customShadows.z20,
            },
          }}
        >
          <Box sx={{ cursor: 'pointer', pb: 4 }}>
            <Typography
              noWrap
              variant="subtitle2"
              sx={{
                pr: 1,
                pl: 6,
                height: 72,
                lineHeight: '72px',
                transition: (theme) =>
                  theme.transitions.create('opacity', {
                    duration: theme.transitions.duration.shortest,
                  }),
                ...(completed && {
                  opacity: 0.48,
                }),
              }}
            >
              {name}
            </Typography>
            <Typography
              noWrap
              variant="caption"
              sx={{
                pr: 1,
                pl: 5,
              }}
            >
              <strong>{translates.quantity}:</strong> {quantity}
            </Typography>
            <Typography
              noWrap
              variant="caption"
              sx={{
                pr: 1,
                pl: 5,
              }}
            >
              <strong>{translates.price}: </strong> {currentFormat(price)}
            </Typography>
          </Box>
        </Paper>
      )}
    </Draggable>
  );
}
